/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import cacheAxios from '../../util/cacheAxios';

const orgChartAxios = axios.create();
const cache = new Map();
cacheAxios(orgChartAxios, cache);

orgChartAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });

export default {
  state: {
    orgChartCompanies: [],
    topCharts: [],
    topCompaniesPeople: {},
    selectedCompanyPeoples: [],
  },
  mutations: {
    setSelectedCompanyPeoples(state, peoples) {
      state.selectedCompanyPeoples = peoples;
    },
    setTopCompaniesPeople(state, peoples) {
      state.topCompaniesPeople = peoples;
    },
    setFilteredOrgCompanies(state, companies) {
      state.orgChartCompanies = companies;
    },
    setTopCharts(state, companies) {
      state.topCharts = companies;
    },
  },
  actions: {
    filterOrgChartCompanies({
      commit,
    }, filter) {
      return orgChartAxios.post('/aims/api/orgChart/filterCompanies', filter, {
          cache: true,
          cacheKey: filter,
        })
        .then((res) => {
          if (res.data) {
            commit('setFilteredOrgCompanies', res.data.all);
            commit('setTopCharts', res.data.top);
          } else {
            commit('setFilteredOrgCompanies', []);
            commit('setTopCharts', []);
          }
        });
    },
    loadTopCharts({
      state,
      commit,
    }) {
      return orgChartAxios.post('/aims/api/orgChart/charts', state.topCharts.map(c => c.companyId))
        .then((res) => {
          if (res.data) {
            commit('setTopCompaniesPeople', res.data);
          }
        });
    },
    loadChart({
      state,
      commit,
    }, company) {
      return orgChartAxios.post('/aims/api/orgChart/charts', [company.companyId])
        .then((res) => {
          if (res.data) {
            commit('setSelectedCompanyPeoples', res.data[company.companyId]);
          }
        });
    },
  },
  getters: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/orgChartModule.js